import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { AppState } from 'src/app/app.state';
import { selectCurrentPhase } from 'src/app/roles/da-engineer/project-dashboard/store/project.selectors';
import { createPeerPoolDiscipline } from '../../store/global-settings.actions';
import {
  SMEDisciplinePeerPoolStatus,
  WorkplanStatus,
} from 'src/app/shared/models/autogenerated';
import {
  ClearAsyncErrorAction,
  SetAsyncErrorAction,
  SetValueAction,
} from 'ngrx-forms';
import {
  codeRepeatedErrorMessage,
  codeRepeatedValidator,
  CodeRepeatedValidator,
} from 'src/app/shared/store/custom-validators/code-repeated-validator';
import {
  clearPeerPoolDisciplineForm,
  loadPeerPoolDiscipline,
  updatePeerPoolDiscipline,
} from '../../store/global-settings.actions';
import {
  selectAllPeerPoolDisciplines,
  selectPeerPoolDisciplineForm,
} from '../../store/global-settings.selectors';
import { ToastMessagesService } from 'src/app/shared/services/toast-messages.service';
import { Constants } from 'src/app/shared/utils/constants';

@Component({
  standalone: false,
  selector: 'app-peer-pool',
  templateUrl: './peer-pool-discipline-details-dialog.component.html',
  styleUrls: ['./peer-pool-discipline-details-dialog.component.scss'],
})
export class PeerPoolDisciplineDetailsDialogComponent {
  formState$ = this.store.select(selectPeerPoolDisciplineForm);
  currentPhase$ = this.store.select(selectCurrentPhase);
  PEER_POOL_STATUS = SMEDisciplinePeerPoolStatus;
  isNew: boolean;
  readonly WorkplanStatus = WorkplanStatus;
  readonly peerPoolDisciplineId?: string;

  constructor(
    private store: Store<AppState>,
    private dialogRef: MatDialogRef<PeerPoolDisciplineDetailsDialogComponent>,
    private toastMessagesService: ToastMessagesService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      isNew: boolean;
      peerPoolDisciplineId: string | undefined;
    }
  ) {
    this.isNew = data.isNew;
    this.peerPoolDisciplineId = data.peerPoolDisciplineId;

    if (!this.isNew) {
      this.store.dispatch(
        loadPeerPoolDiscipline({
          peerPoolDisciplineId: this.peerPoolDisciplineId!,
        })
      );
    }
  }

  unsorted(a: any, b: any): number {
    return 0;
  }

  save(isNew: boolean) {
    this.formState$.pipe(take(1)).subscribe((form) => {
      if (!form.isValid) {
        this.toastMessagesService.displayWarning(
          Constants.ITEMS_REQUIRED_YOUR_ATTENTION
        );
        return;
      }

      isNew
        ? this.store.dispatch(createPeerPoolDiscipline())
        : this.store.dispatch(
            updatePeerPoolDiscipline({
              peerPoolDisciplineId: this.peerPoolDisciplineId!,
            })
          );
      this.closeWindow();
    });
  }

  closeWindow() {
    this.dialogRef.close();
    this.store.dispatch(clearPeerPoolDisciplineForm());
  }

  onChangeCode(event: any): void {
    const peerPool$ = this.store.select(selectAllPeerPoolDisciplines);
    this.formState$.pipe(take(1)).subscribe((form) => {
      const validValue = event.target.value
        .replace(/[^a-zA-Z0-9&]/g, '')
        .toUpperCase();
      this.store.dispatch(
        new SetValueAction(form.controls.code.id, validValue)
      );

      peerPool$.pipe(take(1)).subscribe((peerPool) => {
        const errors = CodeRepeatedValidator(validValue, peerPool);
        if (errors && errors[codeRepeatedValidator]) {
          this.store.dispatch(
            new SetAsyncErrorAction(
              form.controls.code.id,
              codeRepeatedValidator,
              codeRepeatedErrorMessage
            )
          );
        } else {
          this.store.dispatch(
            new ClearAsyncErrorAction(
              form.controls.code.id,
              codeRepeatedValidator
            )
          );
        }
      });
    });
  }
}
